import { WritePayload } from 'spraypaint/lib/util/write-payload';
import { generateTempId } from 'spraypaint/lib/util/temp-id';
/* eslint no-underscore-dangle: off */

/**
 * Original implementation:
 * https://github.com/graphiti-api/spraypaint.js/blob/master/src/util/write-payload.ts#L186
 */

WritePayload.prototype._processRelatedModel = function (model, nested, idOnly) {
  var _this = this;

  model.clearErrors();

  if (!model.isPersisted && !model.temp_id) {
    model.temp_id = generateTempId();
  }

  var wp = new WritePayload(model, nested, idOnly);
  var relatedJSON = wp.asJSON().data;

  if (!this._isNewAndMarkedForDestruction(model)) {
    this._pushInclude(relatedJSON);
  }

  wp.included.forEach(function (incl) {
    if (!_this._isNewAndMarkedForDestruction(model)) {
      _this._pushInclude(incl);
    }
  });

  var resourceIdentifier = this._resourceIdentifierFor(model);

  return resourceIdentifier;
};
/**
 * Original implementation:
 * https://github.com/graphiti-api/spraypaint.js/blob/master/src/util/write-payload.ts#L256
 */


WritePayload.prototype._isIncluded = function (include) {
  return this.included.some(function (incl) {
    if (incl.type === include.type && incl.id && include.id) {
      return incl.id === include.id;
    }

    return incl['temp-id'] && include['temp-id'] && incl['temp-id'] === include['temp-id'];
  });
};